import { FC } from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import useStore from '@hooks/useStore';
import useStyles from './styles';

export interface IFormSectionHeader {
  title: string;
  isOpen: boolean;
  onClick: () => void;
}

const FormSectionHeader: FC<IFormSectionHeader> = ({ title, isOpen, ...props }) => {
  const {
    links: {
      coBrandingConfig: { secondaryColor },
    },
  } = useStore();
  const css = useStyles({ secondaryColor });

  return (
    <ListItem {...props} button>
      <ListItemText primary={<strong className={css.title}>{title}</strong>} />
      {isOpen ? <ExpandLess className={css.icon} /> : <ExpandMore className={css.icon} />}
    </ListItem>
  );
};

export default FormSectionHeader;
